(function () {
  function toAmsterdamDateKey(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).formatToParts(date);
    var values = {};

    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });

    return Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day));
  }

  function parseDateKey(value) {
    var parts = String(value || '').split('-').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) return NaN;
    return Date.UTC(parts[0], parts[1] - 1, parts[2]);
  }

  function formatNumber(value) {
    return new Intl.NumberFormat('nl-NL').format(value);
  }

  function initialiseKlaviyoSignup(root) {
    var form = root.querySelector('.exclusive-deals__form');
    var companyId = String(root.dataset.klaviyoCompanyId || '').trim();
    var listId = String(root.dataset.klaviyoListId || '').trim();

    if (!form || !companyId || !listId) return;

    form.addEventListener('submit', function (event) {
      if (form.dataset.klaviyoSubmitted === 'true') {
        event.preventDefault();
        return;
      }

      var emailInput = form.querySelector('[name="contact[email]"]');
      var firstNameInput = form.querySelector('[name="contact[first_name]"]');
      var submitButton = form.querySelector('[type="submit"]');
      var email = emailInput ? emailInput.value.trim() : '';

      if (!email) return;

      event.preventDefault();
      form.dataset.klaviyoSubmitted = 'true';

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }

      var profileAttributes = {
        email: email,
        subscriptions: {
          email: {
            marketing: {
              consent: 'SUBSCRIBED'
            }
          }
        },
        properties: {
          'Signup Source': 'Meta Sign-up 2026 | Black Friday'
        }
      };

      if (firstNameInput && firstNameInput.value.trim()) {
        profileAttributes.first_name = firstNameInput.value.trim();
      }

      var payload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Meta Sign-up 2026 | Black Friday',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttributes
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: listId
              }
            }
          }
        }
      };
      var controller = typeof AbortController === 'function' ? new AbortController() : null;
      var timeout = window.setTimeout(function () {
        if (controller) controller.abort();
      }, 4000);
      var requestOptions = {
        method: 'POST',
        headers: {
          accept: 'application/vnd.api+json',
          'content-type': 'application/vnd.api+json',
          revision: '2026-10-15'
        },
        body: JSON.stringify(payload),
        keepalive: true
      };

      if (controller) requestOptions.signal = controller.signal;

      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(companyId), requestOptions)
        .then(function (response) {
          if (!response.ok) throw new Error('Klaviyo subscription failed with status ' + response.status);
        })
        .catch(function (error) {
          if (window.console && typeof window.console.warn === 'function') {
            window.console.warn('Klaviyo-inschrijving kon niet worden bevestigd; Shopify verwerkt het formulier verder.', error);
          }
        })
        .then(function () {
          window.clearTimeout(timeout);
          HTMLFormElement.prototype.submit.call(form);
        });
    });
  }

  function initialiseCampaign(root) {
    if (root.dataset.exclusiveInitialised === 'true') return;
    root.dataset.exclusiveInitialised = 'true';

    var deadline = new Date(root.dataset.deadline).getTime();
    var timer = {
      days: root.querySelector('[data-exclusive-days]'),
      hours: root.querySelector('[data-exclusive-hours]'),
      minutes: root.querySelector('[data-exclusive-minutes]'),
      seconds: root.querySelector('[data-exclusive-seconds]')
    };
    var countdownLabel = root.querySelector('[data-exclusive-countdown-label]');
    var expiredAnnouncement = root.querySelector('[data-exclusive-expired]');
    var expiredCopy = root.dataset.expiredCopy || 'De exclusive deals zijn gestart.';
    var interval;

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function updateTimer() {
      var remaining = deadline - Date.now();
      var expired = !Number.isFinite(deadline) || remaining <= 0;

      if (expired) remaining = 0;

      if (timer.days) timer.days.textContent = pad(Math.floor(remaining / 86400000));
      if (timer.hours) timer.hours.textContent = pad(Math.floor((remaining % 86400000) / 3600000));
      if (timer.minutes) timer.minutes.textContent = pad(Math.floor((remaining % 3600000) / 60000));
      if (timer.seconds) timer.seconds.textContent = pad(Math.floor((remaining % 60000) / 1000));

      if (expired) {
        if (countdownLabel) countdownLabel.textContent = expiredCopy;
        if (expiredAnnouncement && !expiredAnnouncement.textContent) expiredAnnouncement.textContent = expiredCopy;
        if (interval) window.clearInterval(interval);
      }

      return expired;
    }

    if (!updateTimer()) interval = window.setInterval(updateTimer, 1000);

    initialiseKlaviyoSignup(root);

    var total = Math.max(1, Number(root.dataset.totalSpots) || 10000);
    var startingAvailable = Math.min(total, Math.max(0, Number(root.dataset.startingAvailable) || total));
    var dailyDecrease = Math.max(0, Number(root.dataset.dailyDecrease) || 0);
    var startDate = parseDateKey(root.dataset.spotsStartDate);
    var availableElement = root.querySelector('[data-exclusive-available]');
    var totalElements = root.querySelectorAll('[data-exclusive-total]');
    var progress = root.querySelector('[data-exclusive-spots-progress]');
    var progressFill = root.querySelector('[data-exclusive-spots-fill]');
    var spotsInterval;

    totalElements.forEach(function (element) {
      element.textContent = formatNumber(total);
    });

    function updateSpots() {
      var currentDate = toAmsterdamDateKey(new Date());
      var daysElapsed = Number.isFinite(startDate) ? Math.max(0, Math.floor((currentDate - startDate) / 86400000)) : 0;
      var available = Math.max(0, startingAvailable - (daysElapsed * dailyDecrease));
      var claimed = Math.max(0, total - available);
      var percentage = Math.min(100, Math.max(0, (claimed / total) * 100));

      if (availableElement) availableElement.textContent = formatNumber(available);
      if (progress) {
        progress.setAttribute('aria-valuenow', String(claimed));
        progress.setAttribute('aria-valuemax', String(total));
        progress.setAttribute('aria-label', formatNumber(available) + ' van de ' + formatNumber(total) + ' plekken beschikbaar');
      }
      if (progressFill) progressFill.style.width = percentage + '%';
    }

    updateSpots();
    spotsInterval = window.setInterval(function () {
      if (!root.isConnected) {
        window.clearInterval(spotsInterval);
        return;
      }
      updateSpots();
    }, 60000);
  }

  function initialiseAll(scope) {
    scope.querySelectorAll('[data-exclusive-deals]').forEach(initialiseCampaign);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initialiseAll(document);
    });
  } else {
    initialiseAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialiseAll(event.target);
  });
})();
